import { PluginType, type IExportPlugin } from '@/version-types';
import { TextEditorPlugin } from './manager';
import { TextEditorView } from './views/editor';

export const textEditorPlugin: IExportPlugin = {
    sort: 11,
    type: PluginType.STAGE,
    name: 'text-editor',
    render() {
        return <TextEditorView />;
    },
    createInstance(context) {
        return [{ key: 'TextEditorPlugin', value: new TextEditorPlugin(context.identity) }];
    },
};
